import React from 'react';
import url from 'url';
import {
  FaTachometerAlt,
  FaGem,
  FaList,
  FaGithub,
  FaRegLaughWink,
  FaHeart,
} from 'react-icons/fa';
import { EuiIcon } from '@elastic/eui';
// import 'react-pro-sidebar/dist/css/styles.css';
import { menuGroups } from '../app-constants/common';
// import sidebarBg from '../assets/images/bg1.jpeg';
import { Button, Divider, Menu, Switch } from 'antd';
import {
  MailOutlined,
  AppstoreOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { getMessage, idb, parseJSON } from 'utils';
import { includes, first, groupBy, map, size, isArray } from 'lodash';
import { useSelector } from 'react-redux';
import { RootState } from 'reducers/root';

const Aside = (props) => {
  const { collapsed, rtl, toggled, handleToggleSidebar, goTo } = props;

  const pageList = useSelector((state: RootState) => state.auth.pageList) || [];
  const [selectedKeys, setSelectedKeys] = React.useState([]);
  const menuRef = React.createRef<any>();

  const buildMenu = (filterFn) => {
    const menus = groupBy(pageList.filter(filterFn), (t) => t.MENU_NAME) as any;
    const result = [];
    Object.keys(menus).map((p, index) => {
      if (!p || size(menus[p]) === 1) {
        map(menus[p], (item) => {
          if (!item.PAGE_PATH) return;
          result.push(
            <Menu.SubMenu
              className="no-sub"
              // style={{
              //   color: includes(selectedKeys, `SING_${item.PAGE_PATH}`)
              //     ? '#1890ff'
              //     : '#000000d9',
              // }}
              onTitleClick={() => {
                props.goTo(url.resolve('/', item.PAGE_PATH));
              }}
              key={`SING_${item.PAGE_PATH}`}
              icon={<EuiIcon type={item.PAGE_ICON} />}
              title={getMessage(item.PAGE_TITLE)}
            ></Menu.SubMenu>
          );
        });
      } else {
        const menuItem = first(menus[p]) as any;
        if (!menuItem) return;
        result.push(
          <Menu.SubMenu
            key={`MENU_${menuItem.PAGE_PATH}`}
            icon={<EuiIcon type={menuItem.MENU_ICON} />}
            title={getMessage(menuItem.MENU_TITLE)}
          >
            {map(menus[p], (itemSub) => (
              <Menu.Item
                icon={<EuiIcon type={itemSub.PAGE_ICON} />}
                onClick={() => {
                  props.goTo(url.resolve('/', itemSub.PAGE_PATH));
                }}
                key={`SUB_${itemSub.PAGE_PATH}`}
              >
                {getMessage(itemSub.PAGE_TITLE)}
              </Menu.Item>
            ))}
          </Menu.SubMenu>
        );
      }
    });
    return result;
  };
  const topMenu = buildMenu(
    (p) => p.MENU_GROUP === menuGroups.TOP || p.PAGE_GROUP === menuGroups.TOP
  );

  const mainMenu = buildMenu((p) => {
    return p.MENU_GROUP === menuGroups.MAIN || p.PAGE_GROUP === menuGroups.MAIN;
  });
  const bottomMenu = buildMenu(
    (p) =>
      p.MENU_GROUP === menuGroups.BOTTOM || p.PAGE_GROUP === menuGroups.BOTTOM
  );

  //   React.useEffect(() => {
  //     if (size(pageList) > 0 && size(selectedKeys) === 0) {
  //       setSelectedKeys(map(pageList, (i) => i.PAGE_PATH));
  //     }
  //   }, [pageList]);

  React.useEffect(() => {
    const v = localStorage.getItem('SELECTED_MENUS');
    const parse = parseJSON(v, []);
    if (!v || size(selectedKeys) > 0) {
      localStorage.setItem('SELECTED_MENUS', JSON.stringify(selectedKeys));
    }
  }, [selectedKeys]);

  React.useEffect(() => {
    const v = localStorage.getItem('SELECTED_MENUS');
    const parse = parseJSON(v, []);
    setSelectedKeys(parse);
  }, []);

  return (
    <Menu
      //   onClick={(e) => {
      //     setSelectedKeys([e.key]);
      //   }}
      // inlineCollapsed={true}
      triggerSubMenuAction="hover"
      //   selectedKeys={selectedKeys}
      style={{ width: 240 }}
      openKeys={selectedKeys}
      mode="inline"
      ref={menuRef}
      onOpenChange={(k) => {
        setSelectedKeys(k);
      }}
      //   openKeys={selectedKeys}
    >
      {topMenu}
      {mainMenu}
      <Divider />
      {bottomMenu}
    </Menu>
  );
};

export default Aside;
